module.exports = __webpack_public_path__ + "static/media/zhBankCard.134875de.png";